module.exports = __webpack_public_path__ + "img/zztbg-3.fe6a74e9.png";